import { Pipe, PipeTransform } from "@angular/core";
import { getApprovedProductRequestItemCount } from "../helpers/get-approved-product-request-item-count";
import { ProductRequest } from "../models/ProductRequest";

@Pipe({name: 'approvedProductRequestItemCount'})
export class ApprovedProductRequestItemCountPipe implements PipeTransform {
  transform(value: ProductRequest): number {
    return getApprovedProductRequestItemCount(value);
  }
}